import type { ImgHTMLAttributes } from "react";

interface OptimizedImageProps
    extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet"> {
    src: string;
    webpSrc?: string;
}

const OptimizedImage = ({
    src,
    webpSrc,
    alt,
    loading = "lazy",
    decoding = "async",
    ...props
}: OptimizedImageProps) => {
    const image = (
        <img
            src={src}
            alt={alt}
            loading={loading}
            decoding={decoding}
            {...props}
        />
    );

    if (!webpSrc) return image;

    return (
        <picture className="contents">
            <source srcSet={webpSrc} type="image/webp" />
            {image}
        </picture>
    );
};

export default OptimizedImage;
